import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=81b10cb2&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=81b10cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b10cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\wu\\shop_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81b10cb2')) {
      api.createRecord('81b10cb2', component.options)
    } else {
      api.reload('81b10cb2', component.options)
    }
    module.hot.accept("./page-header.vue?vue&type=template&id=81b10cb2&scoped=true&", function () {
      api.rerender('81b10cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page-header/page-header.vue"
export default component.exports